<template>
  <div
    class="border dark:border-surface-700 rounded-lg ring-2 hover:shadow duration-500"
    :class="{
      'ring-primary bg-primary-100 dark:bg-primary-900': isActive,
      'ring-transparent hover:ring-surface-400 dark:hover:ring-surface-600': !isActive,
      'p-2': size === 'small',
      'p-4': !size || size === 'default',
    }"
    role="button"
    data-testid="scheduled-content-preview-card"
    @click="setActiveContent"
  >
    <!-- WordPress -->
    <div
      v-if="isWordPress"
      class="mb-4 relative overflow-hidden"
      :class="size === 'small' ? 'h-64' : 'h-96'"
    >
      <!-- <p>{{ post.text }}</p> -->
      <MarkdownText :text="truncatedText" />

      <div
        class="absolute bottom-0 w-full h-20 bg-linear-to-b from-transparent"
        :class="
          isActive
            ? 'to-primary-100 dark:to-primary-900'
            : 'to-surface-0 dark:to-surface-800'
        "
      ></div>
    </div>

    <!-- social -->
    <div v-else>
      <div class="flex gap-2 items-center mb-2">
        <span
          class="grid h-7 w-7 place-content-center rounded-md bg-primary text-surface-0"
        >
          <component :is="icon" v-if="icon" class="h-5 w-5" />
          <i v-else class="pi pi-clock text-lg" />
        </span>
        <p class="capitalize font-semibold text-lg">
          {{ $t("socialPlatformPost", { platform: socialPlatform || "" }) }}
        </p>
      </div>
      <div
        v-if="post?.videos?.length"
        class="bg-surface-200 dark:bg-surface-900/40 rounded-lg relative mt-2 overflow-hidden"
        :class="size === 'small' ? 'h-32' : 'h-56'"
      >
        <PostImageGallery :is-scheduled="true" :videos="post.videos" />
      </div>
      <div
        v-else-if="post?.images?.length"
        class="bg-surface-200 dark:bg-surface-900/40 rounded-lg relative mt-2"
        :class="
          size === 'small'
            ? 'h-32'
            : 'h-40 @clg:h-44 not-supports-cq:lg:h-44 @cxl:h-56 not-supports-cq:xl:h-56'
        "
      >
        <PostImageGallery :is-scheduled="true" :images="post.images" />
      </div>
      <p class="mt-1 text-sm mb-1">{{ truncatedText }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { IContentSelectOption } from "@/types/content";
import type { ScheduledContentType } from "@/types/contentCalendar";
import PostImageGallery from "../singleTask/result/meta/PostImageGallery.vue";

const props = defineProps<{
  isActive?: boolean;
  maxLength?: number;
  post?: IContentSelectOption | null;
  postType?: ScheduledContentType | null;
  size?: "small" | "default";
  fallback?: string;
  hideTag?: boolean;
}>();
const emit = defineEmits<{
  select: [];
}>();

const socialPlatform = computed(() => {
  return props.postType?.split("/")?.[1];
});

const isWordPress = computed(
  () => props.postType === "social-media/wordpress/post-to-wordpress"
);

const truncatedText = computed(() => {
  const text = props.fallback || props.post?.text || "";
  if (!props.maxLength) return text;
  return text.length > props.maxLength
    ? truncateStringAfterWord(text, props.maxLength)
    : text;
});

const icon = computed(() => {
  if (!props.postType) return null;
  return getScheduledContentTypeIcon(props.postType);
});

function setActiveContent() {
  emit("select");
}
</script>
